
  // var currentPath = window.location.pathname;
  // if (currentPath.endsWith('/')) {
  //     currentPath = currentPath.slice(0, -1);
  //   }
  // var baseURL = document.getElementById('redirectBtn').getAttribute('href');
  // document.getElementById('redirectBtn').setAttribute('href', baseURL + currentPath);
   // Check if the modal has been closed before
  let isModalClosed = localStorage.getItem('redirectionClosed');
  if (!isModalClosed) {
    // Define the URL for the API
    const apiUrl = 'https://pro.ip-api.com/json/?key=XjCy8wkn8k9YuLG&fields=status,country,countryCode';
    
    // Make a GET request to the API
    fetch(apiUrl)
      .then(response => {
        // Check if the response is successful (status code 200)
        if (response.ok) {
          // Parse the JSON response
          return response.json();
        } else {
          // If there's an error, throw an error with status text
          throw new Error('Failed to fetch data: ' + response.statusText);
        }
      })
      .then(data => {
        // Log the data received from the API
        console.log(data);
        
        // Access specific fields from the response
        const status = data.status;
        const country = data.country;
        const countryCode = data.countryCode;

        window.country = country;
        
        // Populate current country code
        //document.querySelector('.current_country').textContent = countryCode;
        if (countryCode === "US") {
          // Populate detected country code
         // document.querySelector('.detected_country').textContent = '.'+countryCode;
          
          // Show modal and backdrop
          document.querySelector('#country-redirect').classList.add('show');
          document.querySelector('body').classList.add('modal-open');
          document.querySelector('.modal-backdrop').classList.add('show');
         
        }
      })
      .catch(error => {
        // Handle any errors that occur during the fetch operation
        console.error('Error fetching data:', error.message);
      });
  }
  document.addEventListener("DOMContentLoaded", (event) => {
  // Handle close button click event
  document.querySelector('.redirection-close').addEventListener('click', function() {
    document.querySelector('#country-redirect').classList.remove('show');
    document.querySelector('body').classList.remove('modal-open');
    document.querySelector('.modal-backdrop').classList.remove('show');
    localStorage.setItem('redirectionClosed', 'true');
  });
});